// extracted by mini-css-extract-plugin
export default {"link":"BrowserCheck_link__9lE0F"};